import { render } from "./InterfaceSelect.vue?vue&type=template&id=6dd562aa&scoped=true"
import script from "./InterfaceSelect.vue?vue&type=script&lang=js"
export * from "./InterfaceSelect.vue?vue&type=script&lang=js"

import "./InterfaceSelect.vue?vue&type=style&index=0&id=6dd562aa&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd562aa"]])

export default __exports__